<div class="lang-currency_wrapper">
  <div class="lang-currency_wrapper_item">
    <vy-list-dropdown
      [items]="languages"
      [itemSelectedFrom]="languageSubject | async"
      (itemSelected)="updateLanguage($event)"
    ></vy-list-dropdown>
  </div>
  <div class="lang-currency_wrapper_item">
    <vy-list-dropdown
      [items]="currencies"
      [itemSelectedFrom]="currencySubject | async"
      (itemSelected)="updateCurrency($event)"
    ></vy-list-dropdown>
  </div>
</div>

<div class="text-center marginTop-xl">
  <vy-button
    label="header_component.language_currency_selector.confirm"
    (click)="confirmSelection()"
    onkeypress="confirmSelection()"
  ></vy-button>
</div>
